import { FC } from 'react'
import { MdArrowUpward, MdArrowDownward } from 'react-icons/md'

interface TrendBadgeProps {
  pct: number
  inverted?: boolean // true si "subir" es negativo (ej. rechazados). No usado por los 4 KPI actuales.
  dark?: boolean // variante para la card activa (fondo oscuro)
}

/* Badge de tendencia semanal real: verde si sube (positivo para estos 4 KPI), rojo si baja. */
const TrendBadge: FC<TrendBadgeProps> = ({ pct, inverted = false, dark = false }) => {
  const isUp = pct >= 0
  const isGood = inverted ? !isUp : isUp
  const rounded = Math.round(Math.abs(pct))

  const colorClass = isGood
    ? (dark ? 'text-emerald-300 bg-emerald-400/10' : 'text-emerald-700 bg-emerald-50')
    : (dark ? 'text-rose-300 bg-rose-400/10' : 'text-rose-700 bg-rose-50')

  return (
    <span className={`inline-flex items-center gap-0.5 rounded-md px-1.5 py-0.5 text-tiny font-semibold ${colorClass}`}>
      {isUp ? <MdArrowUpward className='text-[13px]' /> : <MdArrowDownward className='text-[13px]' />}
      {rounded}%
    </span>
  )
}

export default TrendBadge
